// usePassportStep.ts
import { useRef, useState } from "react";
import { AxiosError } from "axios";
import { searchPassportByOrderId } from "pages/SignUp/Api";
import { SMVError } from "utils/SMVError";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useApp } from "context/AppContext";

export const usePassportStep = () => {
	const { coTravelers, setPassportDetails } = useApp();
	const navigate = useNavigate();
	const { orderId } = useParams();

	const searchCancelToken = useRef<AbortController>();
	const applicationIdRef = useRef(Object.values(coTravelers)[0]?.application_id ?? "");
	const [applicationId, setApplicationId] = useState(applicationIdRef.current);
	const [isSearching, setIsSearching] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleSearchPassport = async (passport: string) => {
		if (!orderId) {
			navigate("/notfound");
			return;
		}
		searchCancelToken.current?.abort();
		searchCancelToken.current = new AbortController();
		try {
			setIsSearching(true);
			const { data } = await searchPassportByOrderId(orderId, passport, searchCancelToken.current.signal);
			setPassportDetails(data.data);
			applicationIdRef.current = data.data.application_id;
			setApplicationId(data.data.application_id);
		} catch (error) {
			if (error instanceof AxiosError && error.code === "ERR_CANCELED") {
				return;
			}
			throw new SMVError(error);
		} finally {
			setIsSearching(false);
		}
	};

	const handleClaimApplication = async () => {
		if (!orderId) {
			navigate("/notfound");
			return;
		}
		try {
			setIsSubmitting(true);
			// await claimApplicationByApplicationId(applicationIdRef.current, orderId);
			navigate(`/questionnaire/${orderId}?application_id=${applicationIdRef.current}`);
		} catch (error) {
			console.error(error);
		} finally {
			setIsSubmitting(false);
		}
	};

	const [searchParams] = useSearchParams();
	const defaultPassport = Object.values(coTravelers)[0]?.passport ?? searchParams.get("pid") ?? "";

	return {
		applicationId,
		isSearching,
		isSubmitting,
		handleSearchPassport,
		handleClaimApplication,
		defaultPassport
	};
};

